import z from 'zod';
import { type Shift, useConfig } from '@nexelem/config';
import { RequestFormatters } from '@nexelem/utils';
import { getShiftDateRange } from './getShiftDateRange';
import { useAssignAllWorkersMutation } from './useAssignAllWorkersMutation';
import { useAutoAssignmentConfigStore, useResolvedPolicyConfig } from './useAutoAssignmentConfigStore';

export const assignmentFormSchema = z.object({
  date: z.date(),
  queueAreaId: z.number(),
  workerGroupId: z.number(),
});

export type AssignmentFormValues = z.infer<typeof assignmentFormSchema>;

export const useAssignWorkersSubmit = (selectedShifts: Shift['nameKey'][]) => {
  const shifts = useConfig().modules.production.workerModeViewShifts;
  const assignWorkers = useAssignAllWorkersMutation();
  const { policyConfig } = useResolvedPolicyConfig();
  const rankingConfig = useAutoAssignmentConfigStore((state) => state.rankingConfig);

  const submitAssignment = (values: AssignmentFormValues) => {
    const dateRange = getShiftDateRange(shifts, selectedShifts, values.date);

    if (!dateRange) {
      return;
    }

    assignWorkers.mutate({
      from: RequestFormatters.date.withHoursForBackend(dateRange.from),
      to: RequestFormatters.date.withHoursForBackend(dateRange.to),
      machineAreaIds: [values.queueAreaId],
      workerGroupIds: [values.workerGroupId],
      rankingConfig,
      policySettings: policyConfig,
    });
  };

  return { submitAssignment, isSubmitting: assignWorkers.isPending };
};
